import { getDispatcher } from '@soluto-private/mx-analytics';

const _dispatcher = getDispatcher({
    packageName: '@soluto-private/mx-app-header',
    path: '/',
});

export default _dispatcher;
